import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import Button from '../../Button';
import Radio from '../../Form/Radio';
import styles from './ExportFeaturesModal.module.scss';
import { EXPORT_TYPE } from '../../../lib/constants';
import X from '../../../assets/svg/Feather/X';
import AlertCircle from '../../../assets/svg/Feather/AlertCircle';
import Download from '../../../assets/svg/Feather/Download';

function ExportFeaturesModal(props) {
  const [exportType, setExportType] = useState(EXPORT_TYPE.GPX);
  const featureIds = props.featureIds || [];

  const setExportCurry = (type) => {
     return (e) => {
      setExportType(type);
     };
  };

  const closeModal = () => {
    props.dispatch({
      type: 'modals/close'
    });
  };

  const exportFeatures = () => {
    closeModal();

    props.dispatch({
      type: 'toast/show',
      payload: {
        text: 'Exporting your content...',
        loader: true
      }
    });

    props.dispatch({
      type: 'features/exportFeatures',
      payload: {
        fileType: exportType,
        featureIds
      },
      callback: (exportId) => {
        if (!exportId) {
          props.dispatch({
            type: 'toast/show',
            payload: {
              text: 'There was an error generating your export.',
              icon: AlertCircle,
              iconColor: '#FF3B30',
              dismissable: true
            }
          });
        } else {
          props.dispatch({
            type: 'features/getExportPoll-start',
            payload: exportId,
            callback: (exportUrl) => {
              props.dispatch({
                type: 'features/getExportPoll-stop',
              });

              setTimeout(() => {
                if (exportUrl) {
                  props.dispatch({
                    type: 'toast/show',
                    payload: {
                      text: 'Preparing to download...',
                      loader: true
                    }
                  });

                  window.open(exportUrl, '_blank');

                  props.dispatch({
                    type: 'toast/show',
                    payload: {
                      text: 'Click here if download has not started.',
                      icon: Download,
                      dismissable: true,
                      onClick: (e) => {
                        window.open(exportUrl, '_blank');

                        props.dispatch({
                          type: 'toast/dismiss'
                        });
                      }
                    }
                  });
                } else {
                  props.dispatch({
                    type: 'toast/show',
                    payload: {
                      text: 'There was an error fetching your export.',
                      icon: AlertCircle,
                      iconColor: '#FF3B30',
                      dismissable: true
                    }
                  });
                }
              }, 3500);
            }
          });
        }
      }
    });
  };

  return (
    <div className={styles.container}>
      <button className={styles.closeButton} onClick={closeModal}>
        <X width={24} color='#939393' />
      </button>
      <h1 className={styles.title}>Start a New Export</h1>
      <p className={styles.body}>
        {
          exportType === EXPORT_TYPE.GPX ?
          'GPX format only supports waypoints and tracks.' :
          'KML format supports all feature types.'
        }
      </p>
      <div className={styles.radioButtons}>
        <span className={styles.fileType}>File Type: </span>
        <Radio 
          label='.gpx'
          checked={exportType === EXPORT_TYPE.GPX}
          onChange={setExportCurry(EXPORT_TYPE.GPX)}
          className={styles.button}
          name='fileType'
        />
        <Radio 
          label='.kml'
          checked={exportType === EXPORT_TYPE.KML}
          onChange={setExportCurry(EXPORT_TYPE.KML)}
          className={styles.button}
          name='fileType'
        />
      </div>
      <div className={styles.actionButtons}>
        <Button
          theme={Button.THEME.outlinePrimary}
          size={Button.SIZE.medium}
          onClick={closeModal}
        >
          Cancel
        </Button>
        <Button
          theme={Button.THEME.solidPrimary}
          size={Button.SIZE.medium}
          onClick={exportFeatures}
        >
          Export
        </Button>
      </div>
    </div>
  );
}

ExportFeaturesModal.propTypes = {
  featureIds: PropTypes.array
};

export default connect(() => ({}))(ExportFeaturesModal);